import { createToaster } from "@meforma/vue-toaster";

export default {
    methods: {
        processApiResult(result, replacementFields, showSuccessToaster = true, successMessage = 'Saved', errorMessageHeader = 'Save Failed') {
            if(result.errors == null || result.errors.length === 0) {
                if(showSuccessToaster)
                    this.showSuccessToaster(successMessage);
                return result;
            } else {
                this.printErrors(errorMessageHeader, result.errors, replacementFields);
                return result;
            }
        },
        processSaveResult(result, replacementFields, showSuccessToaster = true) {
            if(result.success) {
                if(showSuccessToaster)
                    this.showSuccessToaster('Saved');
                return result;
            } else {
                this.printErrors('Save Failed', result.errors, replacementFields);//<br/><br/>' + result.errors.join("<br/><br/>"));
                return result;
            }
        },
        showSuccessToaster(msg) {
            const toaster = createToaster({
                position: 'top-right',
                duration: 1000
            });

            toaster.success(msg);
        },
        printErrors(errorMessage, errors = null, replacementFields) {
            const toaster = createToaster({
                position: 'top-right',
                duration: 3000
            });

            if(replacementFields) {
                replacementFields.forEach(element => {
                    for(var i = 0; i < errors.length; i++) {
                        errors[i] = errors[i].replaceAll(element.searchString, element.replaceString);
                    }
                });
            }

            if(errors)
                toaster.error(errorMessage + '<br/><br/>' + errors.join("<br/><br/>"));
            else 
                toaster.error(errorMessage);

        },
        processDeactivateResult(result, replacementFields, showSuccessToaster = true) {
            if(result.success) {
                if(showSuccessToaster)
                    this.showSuccessToaster('Record Deactivated');
                return result;
            } else {
                this.printErrors('Deactivation Failed', result.errors, replacementFields);//<br/><br/>' + result.errors.join("<br/><br/>"));
                return result;
            }
        },
        processReactivateResult(result, replacementFields, showSuccessToaster = true) {
            if(result.success) {
                if(showSuccessToaster)
                    this.showSuccessToaster('Record Reactivated');
                return result;
            } else {
                this.printErrors('Reactiviation Failed', result.errors, replacementFields);//<br/><br/>' + result.errors.join("<br/><br/>"));
                return result;
            }
        },
        processDeleteResult(result, replacementFields, showSuccessToaster = true) {
            if(result.success) {
                if(showSuccessToaster)
                    this.showSuccessToaster('Record Deleted');
                return result;
            } else {
                this.printErrors('Delete Failed', result.errors, replacementFields);//<br/><br/>' + result.errors.join("<br/><br/>"));
                return result;
            }
        }
    }
}